import DataTable from "react-data-table-component"
import { customThemeTable } from './SxOneTablePagination'

const OneTablePagination = ({ columns, data, dobleClickCallback, ...rest }) => {
    return (
        <DataTable
            columns={columns}
            data={data}
            customStyles={customThemeTable}
            striped
            noDataComponent={<div style={{ height: '50px', fontSize: '30px' }}>Não há dados para exibição</div>}
            onRowDoubleClicked={(row, event) => dobleClickCallback(row.id)}
            {...rest}
        />
    )
}

export default OneTablePagination
